/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Badge_LabelInputs */

const en_agent_authorization_badge_label = /** @type {(inputs: Agent_Authorization_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow this Agent to add the Seek AI badge to my project footer`)
};

const zh_agent_authorization_badge_label = /** @type {(inputs: Agent_Authorization_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许此 Agent 在我的项目 footer 中添加 Seek AI 徽章`)
};

/**
* | output |
* | --- |
* | "Allow this Agent to add the Seek AI badge to my project footer" |
*
* @param {Agent_Authorization_Badge_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_badge_label = /** @type {((inputs?: Agent_Authorization_Badge_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Badge_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_badge_label(inputs)
	return zh_agent_authorization_badge_label(inputs)
});
export { agent_authorization_badge_label as "agent.authorization.badge_label" }